function getBumexFeatureState(state) {
  return {
    bumexFeatures: state.bumexFeatures.bumexFeatures,
    bumexFeaturesErrors: state.bumexFeatures.bumexFeaturesErrors,
    bumexFeaturesLoading: state.bumexFeatures.bumexFeaturesLoading,
    bumexFeaturesBulkErrors: state.bumexFeatures.bumexFeaturesBulkErrors,
    bumexFeaturesBulkLoading: state.bumexFeatures.bumexFeaturesBulkLoading
  };
}

export { getBumexFeatureState };
